import { OpenInNew } from '@mui/icons-material';
import { Typography } from '@mui/material';
import CustomButton from 'lib/designSystem/Button';
import React from 'react';

interface CobranzaOnlineProps {
  response: {
    data: {
      certificateLink: string;
    };
    success: boolean;
    message: string;
  };
  searched: boolean;
}

const CobranzaOnlineCerificateResponse = (props: CobranzaOnlineProps) => {
  const { response, searched } = props;
  const { data } = response;

  if (!response.success)
    return (
      <div style={{ padding: '0px' }}>
        <Typography variant="body1">
          {searched ? 'No se encontraron resultados' : ''}{' '}
        </Typography>
      </div>
    );

  return (
    <div>
      <CustomButton
        variant="contained"
        color="primary"
        onClick={() => {
          window.open(data.certificateLink, '_blank');
        }}
        startIcon={<OpenInNew />}
      >
        Descargar certificado
      </CustomButton>
    </div>
  );
};

export default CobranzaOnlineCerificateResponse;
